/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { withStyles } from '@material-ui/core'
import RemoteConfigValue from 'remote-config-value'
import { getValue } from 'firebase-utils'

const styles = theme => ({
    notificationBar: {
        width: '100%',
        height: 'fit-content',
        padding: '4px 10px',
        background: theme.palette.info.background,
        zIndex: 3,
        color: theme.palette.info.main,
        position: 'relative',
        textAlign: 'center',
        '& .link': {
            textDecoration: 'underline',
            color: theme.palette.info.darkText,
            cursor: 'pointer'
        }
    }
})

class SmsBlockedBanner extends Component {
    constructor (props) {
        super(props)
        this.state = {
            infoLink: getValue('sms_enrollment_info_link', (value) => this.setState({ infoLink: value }))
        }
        console.log('SmsBlockedBanner constructor', this.state.infoLink)
    }

    render () {
        const { classes } = this.props
        return (
            <div hidden={this.props.hidden} className={`${classes.notificationBar}`} id='notification-bar'>
                <div> <RemoteConfigValue valueId={'sms_enrollment_send_message_block'}/> </div>
                <a className='link' target="_blank" rel="noopener noreferrer" href={this.state.infoLink}> <RemoteConfigValue valueId={'sms_enrollment_send_message_block_more_info'}/> </a>
            </div>
        )
    }
}

export default withStyles(styles)(SmsBlockedBanner)
